/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import { Toggle } from '@pointfive/ui';
import type { ViewModel } from './view-model';

export function RiskProfileView({ m }: { m: ViewModel }) {
  return (
    <div
      style={{
        maxWidth: '880px',
        margin: '0 auto',
        padding: '24px 12px 40px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      {' '}
      <div> </div>{' '}
      <div
        style={{
          border: '1px solid color-mix(in srgb, var(--pos) 25%, transparent)',
          background: 'color-mix(in srgb, var(--pos) 5%, transparent)',
          borderRadius: '12px',
          padding: '13px 16px',
          display: 'flex',
          gap: '11px',
        }}
      >
        {' '}
        <i
          className="ph ph-info"
          style={{ color: 'var(--pos)', fontSize: '15px', flex: 'none', marginTop: '1px' }}
        ></i>{' '}
        <div>
          <div style={{ fontSize: '12px', fontWeight: '500' }}>How the refractory period works</div>
          <div style={{ fontSize: '11px', color: 'var(--muted)', lineHeight: '1.6', marginTop: '4px' }}>
            When you reduce a risk protection (e.g., raise a loss limit, deactivate a lock), the change is
            queued and takes effect after a cooling-off period. This prevents impulsive changes during
            emotionally charged trading states. You can cancel a pending change at any time before it
            activates.
          </div>
        </div>{' '}
      </div>{' '}
      <div
        style={{
          display: 'inline-flex',
          gap: '2px',
          padding: '3px',
          borderRadius: '9px',
          background: 'transparent',
          border: '1px solid var(--l8)',
          alignSelf: 'flex-start',
        }}
      >
        {' '}
        {(m.rpTabs ?? []).map((t, i39) => (
          <Fragment key={i39}>
            {' '}
            <button
              onClick={t?.go}
              style={dc.css(
                `display:inline-flex;align-items:center;gap:6px;padding:6px 14px;border-radius:6px;border:1px solid ${dc.s(t?.bd)};background:${dc.s(t?.bg)};color:${dc.s(t?.fg)};font-size:11.5px;font-weight:500;cursor:pointer`,
              )}
            >
              <i className={`ph ${dc.s(t?.icon)}`} style={{ fontSize: '12px' }}></i>
              {dc.t(t?.label)}
            </button>{' '}
          </Fragment>
        ))}{' '}
      </div>{' '}
      {m.rpTabControls ? (
        <>
          {' '}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            {' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit,minmax(170px,1fr))',
              }}
            >
              {' '}
              <div style={{ padding: '13px 16px', borderRight: '1px solid var(--l6)' }}>
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Controls active
                </div>
                <div
                  style={{
                    fontSize: '19px',
                    fontWeight: '600',
                    marginTop: '4px',
                    fontVariantNumeric: 'tabular-nums',
                    color: 'var(--pos)',
                  }}
                >
                  {dc.t(m.rcActiveCount)}
                </div>
                <div style={{ fontSize: '10px', color: 'var(--muted2)', marginTop: '1px' }}>
                  {'of '}
                  {dc.t(m.rcTotalCount)}
                  {' available'}
                </div>
              </div>{' '}
              {(m.rcSections ?? []).map((sec, i40) => (
                <Fragment key={i40}>
                  {' '}
                  <div style={{ padding: '13px 16px', borderRight: '1px solid var(--l6)' }}>
                    <div
                      style={{
                        fontSize: '9px',
                        letterSpacing: '0.11em',
                        textTransform: 'uppercase',
                        color: 'var(--muted2)',
                        fontWeight: '600',
                      }}
                    >
                      {dc.t(sec?.label)}
                    </div>
                    <div
                      style={dc.css(
                        `font-size:19px;font-weight:600;margin-top:4px;font-variant-numeric:tabular-nums;color:${dc.s(sec?.countFg)}`,
                      )}
                    >
                      {dc.t(sec?.activeN)}
                      <span style={{ fontSize: '12px', color: 'var(--muted2)' }}>/{dc.t(sec?.totalN)}</span>
                    </div>
                    <div style={{ fontSize: '10px', color: 'var(--muted2)', marginTop: '1px' }}>
                      {dc.t(sec?.scopeNote)}
                    </div>
                  </div>{' '}
                </Fragment>
              ))}{' '}
              <div style={{ padding: '13px 16px' }}>
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Applies to
                </div>
                <div style={{ fontSize: '13px', fontWeight: '500', marginTop: '5px' }}>Exness #184745</div>
                <div style={{ fontSize: '10px', color: 'var(--muted2)', marginTop: '2px' }}>
                  Every control is opt-in
                </div>
              </div>{' '}
            </div>{' '}
            {(m.rcSections ?? []).map((sec, i41) => (
              <Fragment key={i41}>
                {' '}
                <div>
                  {' '}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
                    {' '}
                    <i
                      className={`ph ${dc.s(sec?.icon)}`}
                      style={{ fontSize: '14px', color: 'var(--muted)' }}
                    ></i>{' '}
                    <span style={{ fontSize: '12.5px', fontWeight: '500' }}>{dc.t(sec?.label)}</span>{' '}
                    <span style={{ fontSize: '10.5px', color: 'var(--muted2)' }}>{dc.t(sec?.blurb)}</span>{' '}
                    <div
                      style={{
                        flex: '1',
                        height: '1px',
                        background: 'linear-gradient(90deg,var(--l10),transparent)',
                      }}
                    ></div>{' '}
                    <span
                      style={{
                        fontSize: '10.5px',
                        color: 'var(--muted2)',
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    >
                      {dc.t(sec?.count)}
                    </span>{' '}
                  </div>{' '}
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(2,minmax(0,1fr))',
                      gap: '12px',
                      marginTop: '10px',
                      alignItems: 'start',
                    }}
                  >
                    {' '}
                    {(sec?.items ?? []).map((c, i42) => (
                      <Fragment key={i42}>
                        {' '}
                        <div
                          style={dc.css(
                            `background:var(--surface);border:1px solid var(--card-line);box-shadow:var(--shadow-card);border-radius:16px;border-color:${dc.s(c?.cardBd)};padding:15px 18px;display:flex;flex-direction:column;gap:10px`,
                          )}
                        >
                          {' '}
                          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                            {' '}
                            <div
                              style={dc.css(
                                `width:28px;height:28px;border-radius:9px;background:${dc.s(c?.tileBg)};border:1px solid ${dc.s(c?.tileBd)};display:flex;align-items:center;justify-content:center;flex:none`,
                              )}
                            >
                              <i
                                className={`ph ${dc.s(c?.icon)}`}
                                style={dc.css(`font-size:14px;color:${dc.s(c?.tileFg)}`)}
                              ></i>
                            </div>{' '}
                            <div style={{ flex: '1', minWidth: '0' }}>
                              {' '}
                              <div style={dc.css(`font-size:12px;font-weight:500;color:${dc.s(c?.nameFg)}`)}>
                                {dc.t(c?.name)}
                              </div>{' '}
                              <div style={{ fontSize: '9.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                                {dc.t(c?.scope)}
                              </div>{' '}
                            </div>{' '}
                            <Toggle
                              trackBg={c?.trackBg}
                              knobBg={c?.knobBg}
                              knob={c?.knob}
                              onClick={c?.toggle}
                              title={dc.s(c?.toggleLabel)}
                              aria-label={dc.s(c?.toggleLabel)}
                              aria-pressed={dc.b(c?.on)}
                            />{' '}
                          </div>{' '}
                          <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                            {' '}
                            <span
                              style={{
                                fontSize: '9px',
                                letterSpacing: '0.11em',
                                textTransform: 'uppercase',
                                color: 'var(--muted2)',
                                fontWeight: '600',
                              }}
                            >
                              Setting
                            </span>{' '}
                            <div style={{ flex: '1', height: '1px', background: 'var(--l6)' }}></div>{' '}
                            <span
                              style={dc.css(
                                `font-size:11.5px;font-weight:500;color:${dc.s(c?.valueFg)};font-variant-numeric:tabular-nums`,
                              )}
                            >
                              {dc.t(c?.value)}
                            </span>{' '}
                          </div>{' '}
                          {c?.open ? (
                            <>
                              {' '}
                              <div
                                className="pf-in"
                                style={{ display: 'flex', flexDirection: 'column', gap: '9px' }}
                              >
                                {' '}
                                <div style={{ fontSize: '11px', color: 'var(--muted)', lineHeight: '1.55' }}>
                                  {dc.t(c?.desc)}
                                </div>{' '}
                                <div
                                  style={{
                                    border: '1px solid var(--l8)',
                                    borderRadius: '11px',
                                    background: 'var(--l3)',
                                    padding: '4px 12px',
                                  }}
                                >
                                  {' '}
                                  {(c?.params ?? []).map((p, i43) => (
                                    <Fragment key={i43}>
                                      {' '}
                                      <div
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                          gap: '12px',
                                          padding: '7px 0',
                                          fontSize: '11.5px',
                                        }}
                                      >
                                        <span style={{ color: 'var(--muted2)' }}>{dc.t(p?.k)}</span>
                                        <span
                                          style={{
                                            fontVariantNumeric: 'tabular-nums',
                                            color: 'var(--text2)',
                                          }}
                                        >
                                          {dc.t(p?.v)}
                                        </span>
                                      </div>{' '}
                                    </Fragment>
                                  ))}{' '}
                                </div>{' '}
                                {c?.edit ? (
                                  <button
                                    onClick={c.edit}
                                    aria-label={'Edit ' + dc.s(c?.name) + ' limit'}
                                    style={{
                                      marginTop: '8px',
                                      fontSize: '10.5px',
                                      padding: '5px 12px',
                                      borderRadius: '99px',
                                      border: '1px solid var(--l10)',
                                      background: 'transparent',
                                      color: 'var(--text-mid)',
                                      cursor: 'pointer',
                                    }}
                                  >
                                    Edit limit
                                  </button>
                                ) : null}
                                {c?.queuedNote ? (
                                  <div
                                    role="status"
                                    style={{
                                      marginTop: '8px',
                                      fontSize: '10.5px',
                                      color: 'var(--amb)',
                                      lineHeight: 1.5,
                                    }}
                                  >
                                    {dc.t(c.queuedNote)}
                                  </div>
                                ) : null}
                              </div>{' '}
                            </>
                          ) : null}{' '}
                          <button
                            className="scp-4f3e86a"
                            onClick={c?.expand}
                            title={dc.a(c?.expandLabel)}
                            aria-label={dc.a(c?.expandLabel)}
                            aria-expanded={dc.b(c?.open)}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px',
                              width: '100%',
                              padding: '6px',
                              borderRadius: '9px',
                              border: '1px solid var(--l8)',
                              background: 'transparent',
                              color: 'var(--muted2)',
                              fontSize: '10.5px',
                              cursor: 'pointer',
                            }}
                          >
                            {dc.t(c?.expandText)}
                            <i
                              className="ph ph-caret-down"
                              style={dc.css(
                                `font-size:11px;transform:${dc.s(c?.caret)};transition:transform 160ms cubic-bezier(0.16,1,0.3,1)`,
                              )}
                            ></i>
                          </button>{' '}
                        </div>{' '}
                      </Fragment>
                    ))}{' '}
                  </div>{' '}
                </div>{' '}
              </Fragment>
            ))}{' '}
          </div>{' '}
        </>
      ) : null}{' '}
      {m.rpTabMaturity ? (
        <>
          {' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '20px',
            }}
          >
            {' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
              {' '}
              <svg viewBox="0 0 64 64" style={{ width: '56px', height: '56px' }}>
                <circle cx="32" cy="32" r="26" fill="none" stroke="var(--l8)" strokeWidth="6"></circle>
                <circle
                  cx="32"
                  cy="32"
                  r="26"
                  fill="none"
                  stroke="var(--acc-fill)"
                  strokeWidth="6"
                  strokeLinecap="round"
                  strokeDasharray="114 49"
                  transform="rotate(-90 32 32)"
                ></circle>
                <text
                  x="32"
                  y="37"
                  textAnchor="middle"
                  fill="var(--acc)"
                  fontSize="14"
                  fontFamily="Inter"
                  fontWeight="600"
                >
                  L3
                </text>
              </svg>{' '}
              <div>
                <div style={{ fontSize: '13.5px', fontWeight: '500' }}>Risk Maturity — Level 3 of 5</div>
                <div
                  style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '3px', lineHeight: '1.6' }}
                >
                  Controls active for 12 consecutive sessions. Activate a weekly loss limit and hold all
                  controls for 30 days to reach Level 4.
                </div>
              </div>{' '}
            </div>{' '}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3,1fr)',
                gap: '10px',
                marginTop: '16px',
              }}
            >
              {' '}
              <div
                style={{
                  background: 'var(--surface)',
                  borderRadius: '10px',
                  padding: '12px',
                  border: '1px solid var(--l6)',
                }}
              >
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Days protected
                </div>
                <div
                  style={{
                    fontSize: '18px',
                    fontWeight: '600',
                    marginTop: '4px',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  12
                </div>
              </div>{' '}
              <div
                style={{
                  background: 'var(--surface)',
                  borderRadius: '10px',
                  padding: '12px',
                  border: '1px solid var(--l6)',
                }}
              >
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Controls weakened
                </div>
                <div
                  style={{
                    fontSize: '18px',
                    fontWeight: '600',
                    marginTop: '4px',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  0
                </div>
              </div>{' '}
              <div
                style={{
                  background: 'var(--surface)',
                  borderRadius: '10px',
                  padding: '12px',
                  border: '1px solid var(--l6)',
                }}
              >
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Locks triggered
                </div>
                <div
                  style={{
                    fontSize: '18px',
                    fontWeight: '600',
                    marginTop: '4px',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  1
                </div>
              </div>{' '}
            </div>{' '}
          </div>{' '}
        </>
      ) : null}{' '}
      {m.rpTabAudit ? (
        <>
          {' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '8px 18px',
            }}
          >
            {' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '12px 0',
                borderBottom: '1px solid var(--l5)',
              }}
            >
              <span
                style={{
                  fontSize: '10.5px',
                  color: 'var(--faint)',
                  fontVariantNumeric: 'tabular-nums',
                  width: '110px',
                }}
              >
                24 Jul, 07:02
              </span>
              <i className="ph ph-shield-check" style={{ color: 'var(--pos)', fontSize: '13px' }}></i>
              <span style={{ fontSize: '12px', flex: '1' }}>
                Daily Loss Limit activated at 2.0% of balance
              </span>
              <span style={{ fontSize: '10px', color: 'var(--pos)' }}>Immediate</span>
            </div>{' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '12px 0',
                borderBottom: '1px solid var(--l5)',
              }}
            >
              <span
                style={{
                  fontSize: '10.5px',
                  color: 'var(--faint)',
                  fontVariantNumeric: 'tabular-nums',
                  width: '110px',
                }}
              >
                23 Jul, 18:40
              </span>
              <i className="ph ph-shield-check" style={{ color: 'var(--pos)', fontSize: '13px' }}></i>
              <span style={{ fontSize: '12px', flex: '1' }}>
                Drawdown Circuit Breaker activated at 6.0% from peak
              </span>
              <span style={{ fontSize: '10px', color: 'var(--pos)' }}>Immediate</span>
            </div>{' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 0' }}>
              <span
                style={{
                  fontSize: '10.5px',
                  color: 'var(--faint)',
                  fontVariantNumeric: 'tabular-nums',
                  width: '110px',
                }}
              >
                21 Jul, 09:15
              </span>
              <i className="ph ph-clock" style={{ color: 'var(--amb)', fontSize: '13px' }}></i>
              <span style={{ fontSize: '12px', flex: '1' }}>Daily Trade Limit raised 5 → 8 (queued)</span>
              <span style={{ fontSize: '10px', color: 'var(--amb)' }}>24h refractory</span>
            </div>{' '}
          </div>{' '}
        </>
      ) : null}
    </div>
  );
}
